import { createContext, useContext } from "react";
import { ContextProps } from "./types";

export const Context = createContext<ContextProps | null>(null);

export function useSelectedGroup() {
  const ctx = useContext(Context);

  if (ctx === null) {
    throw new Error(
      "useSelectedGroup must be used within a SelectedGroupProvider",
    );
  }
  return ctx;
}
